export const mantenimientoTitulo = "Sitio en Mantenimiento"
let config = localStorage.getItem("config");
let mantenimientoMsj = JSON.parse(config)?.mantenimientoMsj;



export const mantenimientoDescripcion = mantenimientoMsj ? mantenimientoMsj :`
En este momento estamos trabajando en el sitio web para poder 
seguir brindando el mejor servicio posible.
Le pedimos disculpas por cualquier molestia ocasionada.`;
  